import { HouselistNew } from '@/API';
import { ListService } from '@/service/list/ListService';

/**
 * Service for managing user house list FilterPage selections.
 */
export class HouseListService extends ListService<HouselistNew> {}
